import Vue from 'vue';
import { firestoreCollection } from '../firebase/firestore';

const MODULE_PREFIX = 'users';
const GET_USERS_PROFILE = 'usersProfiles';
const GET_USER_INITIALS = 'userInitials';
const GET_USER_NAME = 'userName';
const GET_USER_IS_REGISTERED = 'getUserIsRegistered';
const MUTATION_SET_USER_PROFILE = 'SET_USER_PROFILE';
const MUTATION_REGISTER_USER_PROFILE = 'MUTATION_REGISTER_USER_PROFILE';
const ACTION_GET_USER_PROFILE = 'getUserProfile';

const initialState = {
  users: {},
  registeredUsers: {},
};

const getters = {
  [GET_USERS_PROFILE]: (state) => state.users,
  [GET_USER_INITIALS]: (state) => (userId) => {
    if (userId) {
      const profile = state.users[userId];
      if (!profile) {
        return '';
      }
      return profile.firstName.substring(0, 1) + profile.lastName.substring(0, 1);
    }

    return '';
  },
  [GET_USER_NAME]: (state) => (userId) => {
    if (userId) {
      const profile = state.users[userId];
      if (!profile) {
        return '';
      }
      return `${profile.firstName} ${profile.lastName}`;
    }

    return '';
  },
  [GET_USER_IS_REGISTERED]: (state) => (id) => state.registeredUsers[id],
};

const mutations = {
  [MUTATION_SET_USER_PROFILE]: (state, userProfile) => {
    Vue.set(state.users, userProfile.id, userProfile);
  },
  [MUTATION_REGISTER_USER_PROFILE]: (state, userId) => {
    state.registeredUsers = {
      ...state.registeredUsers,
      [userId]: true,
    };
  },
};

const AVATAR_COLORS = [
  { color: 'amber', text: 'black' }, { color: 'blue', text: 'white' }, { color: 'blue-grey', text: 'white' },
  { color: 'brown', text: 'white' }, { color: 'cyan', text: 'white' }, { color: 'deep-orange', text: 'white' },
  { color: 'deep-purple', text: 'white' }, { color: 'grey', text: 'black' }, { color: 'indigo', text: 'white' },
  { color: 'light-blue', text: 'white' }, { color: 'light-green', text: 'black' }, { color: 'lime', text: 'black' },
  { color: 'orange', text: 'black' }, { color: 'pink', text: 'white' }, { color: 'purple', text: 'white' },
  { color: 'red', text: 'white' }, { color: 'teal', text: 'white' },
];

const randomAvatarColor = () => {
  const randomIndex = Math.floor(Math.random() * AVATAR_COLORS.length);
  const { color } = AVATAR_COLORS[randomIndex];
  let { text } = AVATAR_COLORS[randomIndex];

  const randomPost = Math.random();
  let post = '';
  // Random for post specification of the color;
  // 33% of change of doing no modification;
  if (randomPost < 0.333) {
    // lighten the color and change the text color if over threshold;
    const lighten = Math.round(Math.random() * 5);
    if (lighten >= 2) {
      text = 'black';
    }
    post = ` lighten-${lighten || 1}`;
  } else if (randomPost > 0.666) {
    // darken the color and change the text color if over threshold;
    const darken = Math.round(Math.random() * 4);
    if (darken >= 2) {
      text = 'white';
    }
    post = ` darken-${darken || 1}`;
  }

  return { color: `${color}${post}`, text };
};

const actions = {
  [ACTION_GET_USER_PROFILE]: async ({ commit, state }, userId) => {
    if (!userId) {
      console.error(`users.actions.getUserProfile userId is ${userId}`);
    }

    const { registeredUsers, users } = state;
    if (registeredUsers[userId]) {
      return users[userId];
    }

    const userQuerySnapshot = await firestoreCollection('users').where('id', '==', userId).get();
    if (userQuerySnapshot.empty) {
      throw new Error(`Could not find a user profile for id: ${userId}`);
    } else {
      commit(MUTATION_REGISTER_USER_PROFILE, userId);
    }

    const userData = userQuerySnapshot.docs[0].data();
    const user = {
      avatarColor: randomAvatarColor(),
      id: userId,
      firstName: userData.firstName,
      lastName: userData.lastName,
    };
    commit(MUTATION_SET_USER_PROFILE, user);

    return user;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    usersProfiles: `${MODULE_PREFIX}/${GET_USERS_PROFILE}`,
    userInitials: `${MODULE_PREFIX}/${GET_USER_INITIALS}`,
    userName: `${MODULE_PREFIX}/${GET_USER_NAME}`,
  },
  mutations: {
    SET_USER_PROFILE: `${MODULE_PREFIX}/${MUTATION_SET_USER_PROFILE}`,
  },
  actions: {
    getUserProfile: `${MODULE_PREFIX}/${ACTION_GET_USER_PROFILE}`,
  },
};
